const pauseVideo = {
	$this: $( '#pause-button' )
};

pauseVideo.init = function() {
	pauseVideo.$this.on('click', function(event) {
		event.preventDefault();
		var video = document.getElementById('hero-video');
		var button = document.getElementById('pause-button');
		if (video.paused) {
			video.play();
			button.setAttribute('aria-pressed', 'false');
			button.classList.remove('is-paused');
		} else {
			video.pause();
			button.setAttribute('aria-pressed', 'true');
			button.classList.add('is-paused');
		}
	});

}

export { pauseVideo };
